import * as React from "react";

const SvgIcnFilter = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path fill="currentColor" fillRule="nonzero" d="M8 11h8l-4 4z" stroke="none" strokeWidth={1} />
    </svg>
);

export default SvgIcnFilter;
